exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reviewContainer--3UrG0{display:flex;flex-direction:column;gap:10px}.reviewHeader--2D_mJ{display:flex;align-items:center;gap:10px;font-size:16px}.smallerStars--2W2Ln img{width:16px}.reviewText--2emAt{font-size:16px;overflow-wrap:break-word;word-break:break-word}", ""]);

// Exports
exports.locals = {
	"reviewContainer": "reviewContainer--3UrG0",
	"reviewHeader": "reviewHeader--2D_mJ",
	"smallerStars": "smallerStars--2W2Ln",
	"reviewText": "reviewText--2emAt"
};